/**
 * True when `url` already points at a host — a full media-service URL, a CDN URL, or a
 * protocol-relative one. Used to tell stored absolute logo URLs apart from legacy bare filenames
 * that still need a `{cdn}/uploads/clubs/{clubUuid}/` prefix.
 */
export const isAbsoluteUrl = (url: string): boolean => /^https?:\/\//i.test(url) || url.startsWith('//');
